import { render, staticRenderFns } from "./btnList.vue?vue&type=template&id=59a85d46&scoped=true"
import script from "./btnList.vue?vue&type=script&lang=js"
export * from "./btnList.vue?vue&type=script&lang=js"
import style0 from "./btnList.vue?vue&type=style&index=0&id=59a85d46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a85d46",
  null
  
)

export default component.exports